import { MapContainer, TileLayer, Marker, Polyline, Popup, Tooltip } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Numbered pin as a DivIcon (no external images, matches B&W aesthetic)
function numberedIcon(n, anomaly) {
  const bg = anomaly ? "#E63946" : "#0A0A0A";
  const html = `<div style="
    width:28px;height:28px;border-radius:50%;
    background:${bg};color:#fff;
    display:flex;align-items:center;justify-content:center;
    font-weight:700;font-size:12px;font-family:'IBM Plex Sans',sans-serif;
    border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.4);
  ">${n}</div>`;
  return L.divIcon({
    html,
    className: "ds-step-pin",
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });
}

export default function StepsMap({ steps }) {
  const located = (steps || []).filter((s) => s.location);
  if (located.length === 0) return null;

  const latlngs = located.map((s) => [s.location.lat, s.location.lng]);
  const center = latlngs[0];
  const hasAnomaly = located.some((s) => s.anomaly);

  return (
    <div className="border border-black" data-testid="steps-map">
      <div className="p-3 border-b border-black flex items-center justify-between">
        <div className="font-display text-xs uppercase tracking-widest font-semibold">
          Recorrido · {located.length} paso(s)
        </div>
        {hasAnomaly && (
          <span className="text-[10px] uppercase tracking-widest text-[#E63946] font-semibold">
            Desviación detectada
          </span>
        )}
      </div>
      <MapContainer
        center={center}
        zoom={13}
        scrollWheelZoom={false}
        style={{ height: "340px", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {latlngs.length > 1 && (
          <Polyline positions={latlngs} pathOptions={{ color: "#0A0A0A", weight: 3 }} />
        )}
        {located.map((step, i) => (
          <Marker
            key={step.id}
            position={[step.location.lat, step.location.lng]}
            icon={numberedIcon(i + 1, step.anomaly)}
          >
            <Tooltip direction="top" offset={[0, -12]} opacity={1} permanent={false}>
              <div className="font-semibold">{step.text}</div>
              <div className="text-xs text-zinc-500">
                {new Date(step.created_at).toLocaleString("es-ES")}
              </div>
            </Tooltip>
            <Popup>
              <div className="font-semibold mb-1">
                {i + 1}. {step.text}
              </div>
              <div className="text-xs text-zinc-500 mb-1">
                {new Date(step.created_at).toLocaleString("es-ES")} · {step.author_name}
              </div>
              <div className="text-xs font-mono">
                {step.location.lat.toFixed(5)}, {step.location.lng.toFixed(5)}
                {step.location.accuracy ? ` (±${Math.round(step.location.accuracy)} m)` : ""}
              </div>
              {step.distance_from_prev_km != null && (
                <div
                  className="text-xs mt-1 font-semibold"
                  style={{ color: step.anomaly ? "#E63946" : "#0A0A0A" }}
                >
                  Desde paso anterior: {step.distance_from_prev_km} km
                  {step.anomaly ? " · posible desvío" : ""}
                </div>
              )}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
